import { FunctionComponent } from 'react';
import { CircularProgress } from '@mui/material';

import {
    ButtonRow,
    ForkContainer,
    ForkText,
    SelfAnswerButton,
    SendButton
} from './styled';

interface Props {
    onSelfAnswer: () => void;
    onOffload: () => void;
    isOffloading?: boolean;
    hideSelfAnswer?: boolean;
}

/**
 * Fork shown when the next planning-question batch is technical-phase.
 * The delegator chooses between answering the technical questions
 * themselves (continues the existing PlanningQuestions UI) or handing
 * the rest of the Q&A to a Beehive contributor — see
 * ``POST /api/v1/quest/plan/<id>/offload``.
 */
const TechnicalFork: FunctionComponent<Props> = ({
    onSelfAnswer,
    onOffload,
    isOffloading = false,
    hideSelfAnswer = false
}) => {
    return (
        <ForkContainer>
            <ForkText>
                {hideSelfAnswer
                    ? 'You can still hand the technical questions to Beehive.'
                    : "We've got a few more technical issues that need to be resolved."}
            </ForkText>
            <ButtonRow>
                {!hideSelfAnswer && (
                    <SelfAnswerButton
                        onClick={onSelfAnswer}
                        disabled={isOffloading}
                        variant="contained"
                        disableElevation
                    >
                        Answer by myself
                    </SelfAnswerButton>
                )}
                <SendButton
                    onClick={onOffload}
                    disabled={isOffloading}
                    variant="contained"
                    disableElevation
                >
                    {isOffloading ? (
                        <CircularProgress size={16} sx={{ color: 'inherit' }} />
                    ) : (
                        'Send to Beehive'
                    )}
                </SendButton>
            </ButtonRow>
        </ForkContainer>
    );
};

export default TechnicalFork;
